module.exports = __webpack_public_path__ + "static/media/brycen6.0f33ba7e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen6.gif
// module id = 151
// module chunks = 0